import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Map } from 'immutable';
import { MediaGalleryConstants } from '../../constants';
import Loader from '../_common/Loader';
import { /* ClipImg, */ IconButton, VideoPreview } from '../_common';

const {
  MEDIA_ACTION_FAILED_STATUS, MEDIA_ACTION_STATUS, MEDIA_TYPE,
} = MediaGalleryConstants;

class ThumbnailItem extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    uploadProgress: PropTypes.object,
    onCrop: PropTypes.func,
    onRetry: PropTypes.func,
    onRemove: PropTypes.func,
  }

  static defaultProps = {
    uploadProgress: Map(),
  }

  handleCropClick = e => {
    this.props.onCrop(this.props.item, e);
  }

  handleRetryClick = e => {
    e.stopPropagation();
    this.props.onRetry(this.props.item);
  }

  handleRemoveClick = e => {
    e.stopPropagation();
    this.props.onRemove(this.props.item);
  }

  statusMsg = (status, uploadProgress) => {
    const { intl: { formatMessage } } = this.props;
    switch (status) {
    case MEDIA_ACTION_STATUS.creating:
      return formatMessage({ id: 'media.creating', defaultMessage: '!Uploading...' });
    case MEDIA_ACTION_STATUS.uploading:
      return formatMessage(
        { id: 'media.uploading', defaultMessage: '!Uploading...' },
        { progress: uploadProgress || 0 }
      );
    case MEDIA_ACTION_STATUS.deleting:
      return formatMessage({ id: 'media.deleting', defaultMessage: '!Deleting...' });
    case MEDIA_ACTION_STATUS.updating:
      return formatMessage({ id: 'media.updating', defaultMessage: '!Updating...' });
    case MEDIA_ACTION_STATUS.cropping:
      return formatMessage({ id: 'media.cropping', defaultMessage: '!Cropping...' });
    default:
      return null;
    }
  }

  errorMsg = failedStatus => {
    const { intl: { formatMessage } } = this.props;
    switch (failedStatus) {
    case MEDIA_ACTION_FAILED_STATUS.uploading_once_failed:
    case MEDIA_ACTION_FAILED_STATUS.uploading_more_failed:
      return formatMessage({ id: 'media.upload_failed', defaultMessage: '!Upload failed' });
    case MEDIA_ACTION_FAILED_STATUS.deleting_failed:
      return formatMessage({ id: 'media.delete_failed', defaultMessage: '!Delete failed' });
    default:
      return null;
    }
  }

  render() {
    const {
      item, uploadProgress, onRemove, onRetry, onCrop,
    } = this.props;
    /*
    let {
      x1, y1, x2, y2,
    } = item;
    if (item.default_crop_upper_left) {
      if (item.default_crop_upper_left.x) x1 = item.default_crop_upper_left.x;
      if (item.default_crop_upper_left.y) y1 = item.default_crop_upper_left.y;
    }
    if (item.default_crop_lower_right) {
      if (item.default_crop_lower_right.x) x2 = item.default_crop_lower_right.x;
      if (item.default_crop_lower_right.y) y2 = item.default_crop_lower_right.y;
    }
     */
    //              <ClipImg className="clipImg" src={item.url} x1={x1} y1={y1} x2={x2} y2={y2} />

    return (
      <div>
        <div className="thumbnail-wrapper">
          <div className="thumbnail-content">
            {item.type !== MEDIA_TYPE.video && item.type !== MEDIA_TYPE.pdf
              && (!!item.type || typeof item.id !== 'number') && (
              <img
                className="thumbnail-image"
                src={item.status ? item.url : ((item.type === MEDIA_TYPE.image && item.twokey_thumb_url) || item.url)}
                alt=""
              />
            )}
            {item.type === 'VIDEO' && (<VideoPreview src={item.url} width="150px" height="100px" />)}
          </div>
          {onCrop && item.status !== MEDIA_ACTION_STATUS.uploading
            && item.failed_status !== MEDIA_ACTION_FAILED_STATUS.uploading_once_failed
            && item.failed_status !== MEDIA_ACTION_FAILED_STATUS.uploading_more_failed
            && (item.type === 'IMAGE' || typeof item.id !== 'number') && (
            <div className="thumbnail-crop-overlay">
              <div style={{ float: 'left' }}>
                {item.width ? (
                  <React.Fragment>
                    {item.width}x{item.height}px
                  </React.Fragment>
                ) : (
                  <FormattedMessage id="media.crop_overlay" defaultMessage="!1920x1080px" />
                )}
              </div>
              <IconButton
                style={{ float: 'right', color: '#FFF' }}
                icon="crop"
                onClick={this.handleCropClick}
              />
            </div>
          )}
        </div>
        {item.status === null && item.failed_status !== null && (
          <div className="thumbnail-item-title">
            <div className="error">{this.errorMsg(item.failed_status)}</div>
            {onRetry && item.failed_status === MEDIA_ACTION_FAILED_STATUS.uploading_once_failed && (
              <IconButton
                style={{ fontSize: 12 }}
                icon="refresh"
                onClick={this.handleRetryClick}
              />
            )}
            {onRemove && item.failed_status === MEDIA_ACTION_FAILED_STATUS.uploading_more_failed && (
              <IconButton
                style={{ fontSize: 12 }}
                icon="close"
                onClick={this.handleRemoveClick}
              />
            )}
          </div>
        )}
        {(item.status !== null && item.status !== undefined) && (
          <div className="thumbnail-item-title">
            <Loader />
            <div className="info">{this.statusMsg(item.status, uploadProgress.get(`${item.id}`))}</div>
          </div>
        )}
      </div>
    );
  }
}

export default injectIntl(ThumbnailItem);

